// src/components/ProtectedRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useGlobalContext } from "../context/AuthContext";

type ProtectedRouteProps = {
  children: React.ReactNode;
  requiredUserType?: "admin" | "moderator" | "member";
  redirectTo?: string;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredUserType,
}) => {
  const { user, loading } = useGlobalContext();

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredUserType && user.userType !== requiredUserType) {
    return <p>Access denied</p>;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
